import { prettyPluralize } from 'shared/utils/prettyPluralize';

export function prettyPluralizeAmenity(number: number): string {
  return prettyPluralize(number, ['удобство', 'удобства', 'удобств']);
}
